import { SERVER_URL } from '../config'

export const serverFile = (fileName: string) => {
    return fileName && `${SERVER_URL}/file/${fileName}`
}
